import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Nav from '../navComponents/Nav';

const OnboardingProtectedRoute = ({ component: Component, ...rest }) => {
	const currentUser = useSelector((st) => st.user.currentUser);

	const withNav = (Component) => (props) => {
		return (
			<>
				<Nav />
				<Component {...props} />
			</>
		);
	};

	// Check for onboarding completion using single field
	const isOnboardingCompleted = () => {
		if (!currentUser) {
			return false;
		}
		
		// Use the onboarding_completed field (becomes onboardingCompleted in camelCase)
		return currentUser.onboardingCompleted === true;
	};

	const renderRoute = () => {
		// First check: user must be logged in and verified
		if (!currentUser || !currentUser.verified) {
			return <Redirect to='/login' />;
		}
		
		// Second check: user must have completed onboarding
		if (!isOnboardingCompleted()) {
			return <Redirect to='/onboarding' />;
		}
		
		// All checks passed, render the protected component
		const ComponentWithNav = withNav(Component);
		return ComponentWithNav;
	};

	return (
		<Route
			{...rest}
			render={(props) => {
				const ComponentToRender = renderRoute();
				if (React.isValidElement(ComponentToRender)) {
					return ComponentToRender;
				}
				// If it's a component function, render it with props
				return <ComponentToRender {...props} />;
			}}
		/>
	);
};

export default OnboardingProtectedRoute;